import React, { useState } from 'react';

const GlobalContext = React.createContext();

const GlobalProvider = ({ children }) => {
  const [themeDark, setThemeDark] = useState(false);
  const [videoModalVisible, setVideoModalVisible] = useState(false);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [visibleOffCanvas, setVisibleOffCanvas] = useState(false);
  const [fullScreenLoader, SetFullScreenLoader] = useState(false);
  const [registrationData, setRegistrationData] = useState(null);
  const [productContractFilter, setProductContractFilter] = useState('contractHigh');
  const [quoteLoading, setQuoteLoading] = useState(false)
  const [totalLoading, setTotalLoading ] = useState(false)
  const [APIErrorMsg, setAPIErrorMsg] = useState({ title: '', message: '' })
  const [appMessages, setAppMessages] = useState(null)

  const toggleTheme = () => {
    setThemeDark(!themeDark);
  };

  const toggleVideoModal = () => {
    setVideoModalVisible(!videoModalVisible);
  };

  const toggleErrorModal = () => {
    setErrorModalVisible(!errorModalVisible);
  };

  const toggleOffCanvas = () => {
    setVisibleOffCanvas(!visibleOffCanvas);
  };

  const showFullScreenLoader = () => {
    if (typeof document !== 'undefined' && document) {
      SetFullScreenLoader(true);
      document.body.classList.add('modal-open');
    }
  };

  const hideFullScreenLoader = () => {
    if (typeof document !== 'undefined' && document) {
      SetFullScreenLoader(false);
      document.body.classList.remove('modal-open');
    }
  };

  const goSetRegistrationData = (registrationData) => {
    setRegistrationData(registrationData)
    if (typeof window !== 'undefined' && window) {
      localStorage.setItem('registrationData', JSON.stringify(registrationData));
    }
  }

  const goResetRegistrationData = () => {
    goSetRegistrationData({})
  }

  const goGetRegistrationData = () => {
    if (registrationData) {
      return registrationData
    } else if (typeof window !== 'undefined' && window && localStorage.getItem('registrationData')) {
      var regData = localStorage.getItem('registrationData')
      if (regData && regData !== "undefined") {
        return JSON.parse(regData)
      }
    } else {
      return undefined
    }
  }

  return (
    <GlobalContext.Provider
      value={{
        themeDark,
        toggleTheme,
        videoModalVisible,
        toggleVideoModal,
        visibleOffCanvas,
        toggleOffCanvas,
        showFullScreenLoader,
        hideFullScreenLoader,
        fullScreenLoader,
        registrationData,
        setRegistrationData,
        errorModalVisible,
        setErrorModalVisible,
        toggleErrorModal,
        goSetRegistrationData,
        goGetRegistrationData,
        goResetRegistrationData,
        productContractFilter,
        setProductContractFilter,
        quoteLoading,
        totalLoading,
        setQuoteLoading,
        setTotalLoading,
        APIErrorMsg,
        setAPIErrorMsg,
        setAppMessages,
        appMessages
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContext;
export { GlobalProvider };
